import axios from "axios";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highstock";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import TableContent from "../pages/TableContent";
require("highcharts/modules/annotations")(Highcharts);

const groupBy = function (data, key) {
  return data.reduce(function (carry, el) {
    var group = el[key];
    if (carry[group] === undefined) {
      carry[group] = [];
    }
    carry[group].push(el);
    return carry;
  }, {});
};

async function getCompanyInfo(company_id) {
  return await axios
    .get(`/api/company?id=${company_id}`)
    .then((res) => {
      if (res.data.length < 1) {
        throw new Error("No Data");
      }
      return res.data[0];
    })
    .catch((err) => console.log(err));
}

async function getChartData(company_id) {
  const newdata = [];
  await axios
    .get(`/api/stockprice/company_id/${company_id}`)
    .then((res) => {
      res.data.forEach((item) => {
        newdata.push({
          x: Date.parse(item.date), // milliseconds 단위
          date: item.date,
          open: item.open,
          high: item.high,
          low: item.low,
          close: item.close,
        });
      });
    })
    .catch((err) => console.log(err));

  return newdata;
}

async function getIncomeStatementData(company_id) {
  const newdata = {};
  const dataForIncomeTable = [];
  await axios
    .get(`/api/istatement/company_id/${company_id}`)
    .then((res) => {
      const groupped = groupBy(res.data, "account");
      Object.keys(groupped).forEach((account) => {
        newdata[account] = groupped[account].map((item) => {
          return {
            x: Date.parse(item.date),
            // y: item.value,
            y: item.value !== null ? item.value : 0,
          };
        });
      });

      const grouppedDate = groupBy(
        res.data.filter((item) => item.value !== null),
        "date"
      );

      Object.keys(grouppedDate).forEach((date) => {
        let itemSaving = { date: date.slice(2, 7), sortDate: date };
        grouppedDate[date].forEach((item) => {
          const account = item.account;
          if (account === "revenue") {
            itemSaving["revenue"] = (item.value ? item.value : 0).toFixed(0);
          } else if (account === "operating_profit") {
            itemSaving["operating_profit"] = (
              item.value ? item.value : 0
            ).toFixed(0);
          } else if (account === "net_profit") {
            itemSaving["net_profit"] = (item.value ? item.value : 0).toFixed(0);
          }
        });

        dataForIncomeTable.push(itemSaving);
      });
    })
    .catch((err) => console.log(err));
  dataForIncomeTable.sort((a, b) => {
    return -Date.parse(a.sortDate) + Date.parse(b.sortDate);
  });

  return [newdata, dataForIncomeTable];
}

async function getAnnotationData(company_id, pathname, person = null) {
  if (pathname !== "massshares" && pathname !== "shares" && pathname !== "") {
    return [];
  }
  const url = `/api/${
    pathname !== "massshares" ? "shares" : "massshares"
  }?company_id=${company_id}${
    person !== null ? "&shares.person=" + person : ""
  }`;

  let result = [];
  await axios
    .get(url)
    .then((res) => {
      result = res.data;
    })
    .catch((err) => console.log(err));

  return result;
}

const base_options = {
  // 기초스타일

  chart: {
    // 차트 스타일 설정
    backgroundColor: "transparent",
    zoomType: "x",
    height: `${(6 / 12) * 100}%`,
  },

  accessibility: {
    enabled: false,
  },
  legend: {
    itemStyle: {
      color: "#374151", // Gray 700
      fontSize: "0.8rem",
    },
    itemHiddenStyle: {
      color: "#9CA3AF", // Gray 400
    },
    enabled: true,
  },
  xAxis: {
    labels: {
      format: "{value:%y-%m-%d}",
      style: {
        color: "#374151",
      },
    },
    crosshair: true,
    lineColor: "#E5E7EB",
    tickColor: "#E5E7EB",
  },

  yAxis: [
    {
      title: {
        // 주가차트
        text: "주가(원)",
        style: {
          color: "#374151",
        },
      },
      gridLineColor: "#E5E7EB", // Gray 200
      opposite: false,
      labels: {
        formatter: ({ value }) => {
          return ` ${
            value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "원"
          }`;
        },
        style: {
          color: "#374151",
        },
      },
      crosshair: true,
    },
    {
      title: {
        // 주가차트
        text: "실적(억)",
        style: {
          color: "#374151",
        },
      },
      gridLineColor: "#E5E7EB",
      opposite: true,
      labels: {
        formatter: ({ value }) => {
          return ` ${
            value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "억"
          }`;
        },
        style: {
          color: "#374151",
        },
      },
      crosshair: true,
    },
  ],

  plotOptions: {
    series: {
      turboThreshold: 0,
    },
    candlestick: {
      lineColor: "#0EA5E9", // Sky 500
      color: "#0EA5E9",
      upLineColor: "#E11D48", // Rose 600
      upColor: "#E11D48",
    },
  },
  tooltip: {
    borderRadius: 20,
    outside: true,
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    width: "200px",
    style: {
      color: "#333333",
      fontSize: "12px",
    },
    // xDateFormat: "%Y-%m-%d",
    shared: true,
    shadow: {
        color: 'rgba(0,0,0,0.1)',
        width: 8,
        offsetX: 0,
        offsetY: 2
    },
    borderWidth: 0,
  },
  navigator: {
    height: 20,
    series: {
      color: "#E5E7EB",
      lineColor: "#9CA3AF",
    },
    xAxis: {
      gridLineColor: "#E5E7EB",
    },
  },

  rangeSelector: {
    buttonTheme: {
      // styles for the buttons
      fill: "none",
      stroke: "none",
      "stroke-width": 0,
      r: 8,
      style: {
        color: "#374151",
        fontWeight: "bold",
      },
      states: {
        hover: {},
        select: {
          fill: "#E5E7EB",
          style: {
            color: "#1F2937",
          },
        },
        // disabled: { ... }
      },
    },
  },
  series: [
    {
      type: "candlestick",
    },
  ],
};

export default function StockChart({ company_id, name, person = null }) {
  const [options, setOptions] = useState(base_options);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  const [incomes, setIncomes] = useState();
  const [cachedData, setCachedData] = useState({});

  useEffect(() => {
    const start = async () => {
      // 종목이 바뀌거나 데이터가 없는 경우에만 주가/재무제표 데이터 요청
      const needsFullLoad = !cachedData[company_id];
      
      setIsLoading(true);
      try {
        let currentCompanyInfo = cachedData[company_id]?.companyInfo;
        let chartData = cachedData[company_id]?.chartData;
        let priceMap = cachedData[company_id]?.priceMap;
        let incomedata = cachedData[company_id]?.incomedata;

        if (needsFullLoad) {
          [currentCompanyInfo, chartData, incomedata] = await Promise.all([
            getCompanyInfo(company_id),
            getChartData(company_id),
            getIncomeStatementData(company_id)
          ]);
          
          // 검색 최적화를 위한 Map 생성 (O(N) -> O(1))
          priceMap = new Map(chartData.map(item => [item.x, item.close]));
          
          setCachedData(prev => ({
            ...prev,
            [company_id]: { companyInfo: currentCompanyInfo, chartData, priceMap, incomedata }
          }));
        }

        setIncomes(incomedata[1]);

        let series = [
          {
            type: "candlestick",
            data: chartData,
            name: "주가",
            zIndex: 9999,
          },
        ];

        let title = {
          text: `${name}
          <span style="font-size: 0.8rem; color: #6B7280"> (${(
            currentCompanyInfo.marketcap ?? 0
          )
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}억, PER:${
            currentCompanyInfo.per === 0 ? "-" : currentCompanyInfo.per
          }, PBR:${currentCompanyInfo.pbr} )</span>`,
          style: {
            color: "#111827", // Gray 900
            fontWeight: "bold",
          },
          useHTML: true,
        };

        const events = {
          load: function () {
            const end = chartData[chartData.length - 1].x;
            const start = end - 31556952000;
            this.xAxis[0].setExtremes(start, end);
          },
        };

        const annotationres = await getAnnotationData(
          company_id,
          location.pathname.replace("/", ""),
          person
        );

        const labels = [];
        // 성능 최적화: 최신순으로 정렬 후 상위 100건만 렌더링 (삼성전자 등 대규모 데이터 대비)
        const limitedAnnotations = annotationres
          .sort((a, b) => Date.parse(b.date_changed || b.date) - Date.parse(a.date_changed || a.date))
          .slice(0, 100);

        limitedAnnotations.forEach((item) => {
          const { date, date_changed, person: itemPerson, share_change, holder, current_ratio, previous_ratio, reason } = item;
          const targetDate = Date.parse(date_changed ? date_changed : date);
          
          // Map을 사용한 O(1) 검색으로 최적화
          const closePrice = priceMap.get(targetDate);
          
          if (closePrice !== undefined) {
            labels.push({
              point: {
                xAxis: 0,
                yAxis: 0,
                x: targetDate,
                y: closePrice,
              },
              text: location.pathname.replace("/", "") === "massshares"
                ? `${holder} ${current_ratio}% ${
                    current_ratio - previous_ratio > 0
                      ? "<span style='color: #E11D48'>⬆︎</span>"
                      : current_ratio === previous_ratio
                      ? ""
                      : "<span style='color: #0EA5E9'>⬇︎</span>"
                  }`
                : `<p style='color:#F59E0B;font-size:0.6rem;'>${reason}</p> ${itemPerson} ${
                    share_change > 0
                      ? "<span style='color: #E11D48'>⬆︎</span>"
                      : share_change < 0
                      ? "<span style='color: #0EA5E9'>⬇︎</span>"
                      : reason.includes("+") && reason.includes("-")
                      ? ""
                      : reason.includes("+")
                      ? "<span style='color: #E11D48'>⬆︎</span>"
                      : "<span style='color: #0EA5E9'>⬇︎</span>"
                  }`,
              style: { fontSize: "0.8rem", color: "#374151" },
              useHTML: true,
            });
          }
        });

        const annotations = [{
          labels,
          labelOptions: { backgroundColor: "transparent", borderColor: "transparent", fontWeight: "bold" },
        }];

        // 실적 라인 및 PER 가이드 로직 (데이터 활용 중복 부분 최적화)
        const incomeSeries = Object.keys(incomedata[0]).map(account => ({
          type: "line",
          data: incomedata[0][account],
          color: account === "revenue" ? "#058DC7" : account === "operating_profit" ? "#50B432" : "#ED561B",
          name: account === "revenue" ? "매출" : account === "operating_profit" ? "영업이익" : "순이익",
          yAxis: 1,
          step: "right",
          visible: false,
        })).sort((b, a) => {
          return a.name === "매출" ? 1 : a.name === "영업이익" && b.name !== "매출" ? 1 : -1;
        });

        series.push(...incomeSeries);

        // PER 가이드 라인 생성 로직
        const netProfitDataList = incomedata[0].net_profit;
        const cumulSumList = netProfitDataList?.slice(3)?.map((netprofit, idx) => {
          const sum = netProfitDataList.slice(idx, idx + 4).reduce((a, b) => a + b.y, 0);
          return { x: netprofit.x, cumulativeIncome: parseFloat(sum).toFixed() };
        }).filter((item) => item.cumulativeIncome > 0);

        if (cumulSumList?.length > 0 && cumulSumList[cumulSumList.length - 1].cumulativeIncome > 0) {
          const lastNI = cumulSumList[cumulSumList.length - 1].cumulativeIncome;
          const currentPER = parseFloat(currentCompanyInfo.marketcap / lastNI).toFixed();
          const pers = [currentPER * 0.5, currentPER * 0.7, currentPER, currentPER * 1.3, currentPER * 1.5];

          const perSeriesParent = { name: "PER", id: "PER", data: [], visible: false };
          const perChildSeries = pers.map(per => ({
            type: "line",
            dashStyle: "ShortDash",
            name: `PER${parseFloat(per)?.toFixed(1)}`,
            data: cumulSumList.map(item => ({
              x: item.x,
              y: (parseFloat((item.cumulativeIncome * 100000000) / currentCompanyInfo.listedshares).toFixed() * per)
            })),
            opacity: 0.4,
            linkedTo: "PER",
            yAxis: 0,
            step: "right",
            enableMouseTracking: false,
            zIndex: 0,
            dataLabels: {
              enabled: true,
              overflow: "allow",
              align: "left",
              style: { textOutline: 0, opacity: 0.8 },
              formatter: function () {
                return this.point.x === this.series.xData[this.series.xData.length - 1] ? `<p style="color:${this.series.color}">${this.series.name}</p>` : null;
              }
            }
          }));
          series.push(perSeriesParent, ...perChildSeries);
        }

        setOptions(prev => ({ ...prev, title, series, scrollbar: { height: 1 }, annotations, chart: { ...prev.chart, events } }));
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };
    start();
  }, [company_id, person, cachedData, location.pathname, name]);

  const columns = useMemo(
    () => [
      {
        accessor: "date",
        Header: () => <span className="text-xs ">분기</span>,
        disableFilters: true,
        disableSortBy: true,
        Cell: ({ value }) => <span className="text-xs "> {value}</span>,
      },
      {
        accessor: "revenue",
        Header: () => <span className="text-xs ">매출</span>,
        disableFilters: true,
        disableSortBy: true,
        Cell: ({ value }) => <span className="text-xs "> {value}</span>,
      },
      {
        accessor: "operating_profit",
        Header: () => <span className="text-xs ">OP</span>,
        disableFilters: true,
        disableSortBy: true,
        Cell: ({ value }) => (
          <span
            className={`text-xs ${
              value > 0 ? "text-text-plus" : "text-text-minus"
            }`}
          >
            {value}
          </span>
        ),
      },
      {
        accessor: "net_profit",
        Header: () => <span className="text-xs ">NI</span>,
        disableFilters: true,
        disableSortBy: true,
        Cell: ({ value }) => (
          <span
            className={`text-xs ${
              value > 0 ? "text-text-plus" : "text-text-minus"
            }`}
          >
            {value}
          </span>
        ),
      },
    ],

    []
  );

  return (
    <div className="flex">
      {isLoading ? (
        <div
          className={`w-full h-[400px] text-center bg-gray-100 text-gray-500 p-5 rounded my-2 text-xlg font-bold flex items-center justify-center 
        
        `}
        >
          ....loading....
        </div>
      ) : (
        <>
          <div className={`w-full`}>
            <HighchartsReact
              highcharts={Highcharts}
              options={options}
              constructorType={"stockChart"}
            />
          </div>
          <div className="hidden xl:inline lg:w-[300px]">
            {incomes?.length > 0 ? (
              <TableContent
                isLoading={isLoading}
                columns={columns}
                data={incomes}
                itemPerPage={10}
                enableCompactControlPanel={true}
                disableKeyboardNavigation={true}
              />
            ) : (
              ""
            )}
          </div>
        </>
      )}
    </div>
  );
}
